export function permisosError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.permisos = ''
    state.permiso = ''
    
}
export function setPermisos(state, payload){
    state.permisos = payload.data.permisos
    state.error= false
    state.errorMessage = ''
    
}
export function setPermisoUsuario(state, payload){
    state.permiso = payload.data.permisos
    state.error= false
    state.errorMessage = ''
    
}
export function setIsOk(state,payload){
    state.isOk = payload
}